import { h } from 'preact';

export default props => (
	<svg width="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path d="M5 10H15M2.5 5H17.5M7.5 15H12.5" stroke-width="1.25" stroke-linecap="round" />
	</svg>
);
